import debounce from "../helpers/debounce";

class Header {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.isFixed = passedElement.dataset.headerFixed === 'true';
        self.scrollStyle = passedElement.dataset.headerScroll || 'solid';
    }

    init() {
        let self = this;

        self.setHeightProperty();

        if (self.isFixed) {
            const scrollHandler = debounce(function () {
                self.elem.classList.toggle('is-shrunk', window.scrollY > 0);
            });

            window.addEventListener('scroll', scrollHandler, { passive: true });
        }

        const resizeHandler = debounce(function () {
            self.setHeightProperty();
        });

        window.addEventListener('resize', resizeHandler, { passive: true });
    }

    setHeightProperty() {
        let self = this;

        self.headerHeight = self.elem.offsetHeight;
        document.documentElement.style.setProperty("--header-height", self.headerHeight + 'px');

        const strapline = document.querySelector('.strapline');
        if (strapline) {
            document.documentElement.style.setProperty('--strapline-height', strapline.offsetHeight + 'px');
        }
    }
}

export default Header;
